import sdkProvider from "src/utilities/sdkProvider";
import noticeError from "src/app/utilities/noticeError";
import { EXPERIMENTS } from "./experiments";

export const getFeatures = async () => {
  const features = await sdkProvider("features");
  const clientReady = await features.onReady();

  return {
    features,
    clientReady,
  };
};

export const trackEvent = async (eventKey) => {
  try {
    const { features, clientReady } = await getFeatures();

    if (clientReady.success) {
      features.track(eventKey);
    }
  } catch (error) {
    noticeError(error);
  }
};

export const getBucket = async (key) => {
  const { features, clientReady } = await getFeatures();

  if (clientReady.success) {
    const bucket =
      features.getAllDecisions()[key]?.bucket ||
      EXPERIMENTS.SIERRA_CHAT.VARIATIONS.CONTROL;
    return bucket;
  }

  return null;
};
